import { ADMIN } from './types';

export const updateFieldValue = (fieldValue) => ({
  type: ADMIN.UPDATE_FIELD_VALUE,
  fieldValue,
});

export const updateError = (errorValue) => ({
  type: ADMIN.UPDATE_ERROR,
  errorValue,
});

export const displayToast = (val) => ({
  type: ADMIN.DISPLAY_TOAST,
  val,
});

export const resetValues = () => ({
  type: ADMIN.RESET_VALUES,
});

export const verifyEmailAddress = (activationKey, persona, email) => ({
  type: ADMIN.VERIFY_EMAIL,
  activationKey,
  persona,
  email,
});

export const verifyEmailAddressSuccess = (res) => ({
  type: ADMIN.VERIFY_EMAIL_SUCCESS,
  res,
});

export const verifyEmailAddressFailure = () => ({
  type: ADMIN.VERIFY_EMAIL_FAILURE,
});

export const addUser = (userRequest, isEdit) => ({
  type: ADMIN.ADD_USER,
  userRequest,
  isEdit,
});
export const addTeamMember = (userRequest, isEdit) => ({
  type: ADMIN.ADD_TEAM_MEMBER,
  userRequest,
  isEdit,
});

export const addUserSuccess = (res) => ({
  type: ADMIN.ADD_USER_SUCCESS,
  res,
});
export const progressbufferOn = () => ({
  type: ADMIN.PROGRESS_ON,
});
export const progressbufferOff = (message) => ({
  type: ADMIN.PROGRESS_OFF,
  res: message,
});

export const updateUser = (activationKey, isValid, email, searchKey) => {
  return {
    type: ADMIN.UPDATE_USER,
    activationKey,
    isValid,
    email,
    searchKey,
  };
};

export const updateUserSuccess = (res) => ({
  type: ADMIN.UPDATE_USER_SUCCESS,
  res,
});

export const getUserDetails = (emailId, activationKey) => ({
  type: ADMIN.GET_USER_DETAILS,
  emailId,
  activationKey,
});

export const getUserDetailsSuccess = (response) => ({
  type: ADMIN.GET_USER_DETAILS_SUCCESS,
  response,
});

export const getUserDetailsFailure = (error) => ({
  type: ADMIN.GET_USER_DETAILS_FAILURE,
  error,
});

export const getLanguageDetails = () => ({
  type: ADMIN.GET_LANGUAGE_DETAILS
})

export const getLanguageDetailsSuccess = (response) => ({
  type: ADMIN.GET_LANGUAGE_DETAILS_SUCCESS,
  response
})

export const getLanguageDetailsFailure = (error) => ({
  type: ADMIN.GET_LANGUAGE_DETAILS_FAILURE,
  error
})

export const findIfSingleAccount = (isSingleAccount) => ({
  type: ADMIN.IS_SINGLE_ACCOUNT,
  isSingleAccount,
});

export const fetchRegexRequest = () => ({ type: ADMIN.FETCH_REGEX_REQUEST });
export const fetchRegexSuccess = (response) => ({ type: ADMIN.FETCH_REGEX_SUCCESS, response });
export const fetchRegexFailure = (error) => ({ type: ADMIN.FETCH_REGEX_FAILURE, error });
